import { useI18n } from 'vue-i18n';
import NavigationHelper from '@/util/NavigationHelper';
import { useRouter } from 'vue-router';
import { Forms } from '@/enums/Forms';
import { useTokenStore } from '@/plugins/stores';
import UserController from '@/controllers/UserController';
import { AuthResponseStatus } from '@/enums/AuthResponseStatus';
import AuthenticationHelper from '@/util/AuthenticationHelper';
import { Ref, ref } from 'vue';
import ValidationRules from '@/util/ValidationRules';
import PageHelper from '@/util/PageHelper';
import PolteqButton from '@/components/PolteqButton/PolteqButton.vue';
import PolteqTextField from '@/components/PolteqTextField/PolteqTextField.vue';
import { VForm } from 'vuetify/components';

export default {
  name: 'ChangePasswordForm',
  components: {
    PolteqButton,
    PolteqTextField
  },
  computed: {
    NavigationHelper() {
      return NavigationHelper;
    }
  },
  setup() {
    const i18n = useI18n();
    const router = useRouter();
    const tokenStore = useTokenStore();
    const rules = ValidationRules.getRules();
    const changePasswordForm = ref() as Ref<VForm>;
    const changePassword = async (password: string, newPassword: string) => {
      await changePasswordForm.value.validate();
      if (changePasswordForm.value.isValid) {
        const response = await UserController.changePassword(tokenStore.accessToken, password, newPassword);
        PageHelper.setNotificationMessage(response);
        if (response.status === AuthResponseStatus.SUCCESS) {
          AuthenticationHelper.setTokens(response);
          await NavigationHelper.openForm(router, Forms.PROFILE);
        }
      }
    };
    return {
      i18n,
      router,
      Forms,
      rules,
      changePasswordForm,
      changePassword
    };
  },
  data() {
    return {
      password: '',
      newPassword: '',
      confirmPassword: ''
    };
  }
};
